import React from "react";
import searchImage from "assets/undraw_Check_boxes_re_v40f.png";
import { useNavigate } from "react-router-dom";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Box, Typography } from "@mui/material";

const DefaultProperty = ({ open, onClose }) => {
    const navigate = useNavigate();
    const handleSubmit = () => { navigate("/dashboard"); onClose(); };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth={"sm"}>
            <DialogTitle sx={{ textAlign: "center", fontWeight: 700, fontSize: "1.125rem", color: "#1a2138", pt: 3, pb: 0 }}>
                Select Default Property
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3} p={"5px"}>
                    <Grid item xs={12} container direction="column" alignItems="center">
                        <Box component="img" alt="select" src={searchImage} height="180px" width="180px" sx={{ objectFit: "cover", opacity: 0.85 }} />
                        <Typography variant="body2" mt={2} textAlign="center" sx={{ color: "#5a6a85", maxWidth: 320 }}>
                            You have not selected a default property yet. Please select a default property to proceed.
                        </Typography>
                    </Grid>
                </Grid>
                <DialogActions sx={{ justifyContent: "center", pb: 2, pt: 2 }}>
                    <Button variant="contained" color="primary" onClick={handleSubmit} sx={{ px: 4 }}>Select Property</Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
};

export default DefaultProperty;
